import { render, staticRenderFns } from "./MilageStats.vue?vue&type=template&id=4cd39be8&scoped=true&"
import script from "./MilageStats.vue?vue&type=script&lang=js&"
export * from "./MilageStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd39be8",
  null
  
)

export default component.exports